<script lang="ts" setup>
import { faSort, faSortDown, faSortUp } from "@fortawesome/pro-solid-svg-icons";

interface UITableColumn<T extends Record<string, any> = Record<string, any>> {
    label: string;
    key: keyof T;
    sortable?: boolean;
    direction?: "asc" | "desc";
}

interface UITableHeadProps {
    column: UITableColumn;
}

interface UITableSort {
    key: string;
    direction: "asc" | "desc";
}

const props = defineProps<UITableHeadProps>();

const emit = defineEmits<{
    (e: "sort", v: UITableSort | undefined): void;
}>();

function toggleSort() {
    if (props.column.direction === "asc") {
        emit("sort", undefined);
    } else if (props.column.direction === "desc") {
        emit("sort", {
            key: props.column.key,
            direction: "asc",
        });
    } else {
        emit("sort", {
            key: props.column.key,
            direction: "desc",
        });
    }
}

const icon = computed(() => {
    if (props.column.sortable) {
        if (props.column.direction === "asc") {
            return faSortDown;
        } else if (props.column.direction === "desc") {
            return faSortUp;
        }

        return faSort;
    }

    return undefined;
});
</script>

<template>
    <span>
        <UButton
            v-if="column.sortable"
            variant="ghost"
            color="gray"
            class="-ml-2.5"
            @click="toggleSort"
        >
            {{ column.label }}
            <FontAwesomeIcon :icon="icon" />
        </UButton>
        <span v-else>{{ column.label }}</span>
    </span>
</template>
